import { render } from "./AvatarForm.vue?vue&type=template&id=39c1f5a5"
import script from "./AvatarForm.vue?vue&type=script&lang=js"
export * from "./AvatarForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__